import * as React from 'react';

export default () => {
    return (
        <svg
          xmlns="http://www.w3.org/2000/svg"
          width="32"
          height="32"
          viewBox="0 0 32 32"
        >
          <path d="M31.894 30.53l-15-30c-.339-.678-1.45-.678-1.789 0l-15 30A1 1 0 001 31.978h30a1 1 0 00.894-1.448zM16 3.213l5.382 10.764H10.618L16 3.213zM9.618 15.978h12.764l3 6H6.618l3-6zm-7 14l3-6h20.764l3 6H2.618z"></path>
        </svg>
    );
}